import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import { FaRupeeSign, FaRegCalendar } from "react-icons/fa";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  RupeeIcon,
  CalendarIcon,
  CombineInputGroup,
} from "../Styles/InputStyles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const OthersModal = ({ tenantId, selectedOption, setSelectedOption, addDuesMutate, addDuesLoading, isShowFinalDuesModal }) => {
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [dueDateOpen, setDueDateOpen] = useState(false);
  const formik = useFormik({
    initialValues: {
      title: "",
      amount: "",
      startDate: "",
      dueDate: "",
      endDate: "",
      description: "",
    },

    onSubmit: (values) => {
      if (!values.title) {
        toast.error("Please enter title");
        return;
      }
      if (values.title.length < 4 || values.title.length > 20) {
        toast.error("Title must be between 4 and 20 characters");
        return;
      }

      if (!/^[A-Za-z\s]+$/.test(values.title)) {
        toast.error("Title must contain only alphabets");
        return;
      }
      if (!values.amount) {
        toast.error("Please enter amount");
        return;
      }
      if (values.amount <= 0) {
        toast.error("Amount must be greater than 0");
        return;
      }

      if (values.amount > 1000000) {
        toast.error("Amount cannot be greater than 10,00,000");
        return;
      }
      if (!values.startDate) {
        toast.error("Please select start date");
        return;
      }
      if (!values.dueDate) {
        toast.error("Please select due date");
        return;
      }

      if (!values.endDate) {
        toast.error("Please select end date");
        return;
      } else if (new Date(values.endDate) < new Date(values.startDate)) {
        toast.error("End date cannot be earlier than start date");
        return;
      }
      addDuesMutate({
        amount: Number(values.amount),
        startDate: moment(values.startDate).format("YYYY-MM-DD"),
        dueDate: moment(values.dueDate).format("YYYY-MM-DD"),
        endDate: values.endDate ? moment(values.endDate).format("YYYY-MM-DD") : null,
        description: values.description,
        rentDuration: values.rentDuration,
        type: Number(selectedOption),
        tenantId: tenantId,
        title: values.title,
        ...(isShowFinalDuesModal && { adjustFromRefund: 0 })
      })
    },
  });

  return (
    <Container>
      <form className="px-1  flex flex-col gap-4" onSubmit={formik.handleSubmit}>
        <ScrollableContent className="!max-h-[calc(100vh-200px)]">
          <Wrapper>
            <InputGroup>
              <Label htmlFor="title">Title *</Label>
              <FieldWrappers>
                <input
                  type="text"
                  id="title"
                  placeholder="Enter Title"
                  {...formik.getFieldProps("title")}
                  className="pl-2"
                />
              </FieldWrappers>
            </InputGroup>
            {/* Amount */}
            <InputGroup>
              <Label htmlFor="amount">Amount *</Label>
              <FieldWrappers>
                <RupeeIcon />
                <input
                  type="text"
                  id="amount"
                  placeholder="Enter Amount"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...formik.getFieldProps("amount")}
                  onKeyDown={(e) => {
                    if (!/^\d$/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault();
                    }
                  }}
                  className="pl-6"
                />
              </FieldWrappers>
            </InputGroup>

            {/* Date and Due Date */}
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="startDate">Start Date *</Label>
                <FieldWrappers>
                  {/* <CalendarIcon />
                  <input
                    type="date"
                    id="startDate"
                    {...formik.getFieldProps("startDate")}
                    className="pl-6"
                  /> */}
                  <DatePicker
                    selected={formik.values.startDate ? new Date(formik.values.startDate) : null}
                    onChange={(date) => {
                      formik.setFieldValue("startDate", moment(date).format("YYYY-MM-DD"));
                      setStartDateOpen(false);
                    }}
                    onClickOutside={() => setStartDateOpen(false)}
                    onSelect={() => setStartDateOpen(false)}
                    open={startDateOpen}
                    onInputClick={() => setStartDateOpen(true)}
                    dateFormat="yyyy-MM-dd"
                    className="items-center cursor-pointer"
                    placeholderText="Select start date"
                    showIcon
                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                    showPopperArrow={false}
                    wrapperClassName="w-full"
                    name="startDate"
                    id="startDate"
                    autoComplete="off"
                    onFocus={(e) => e.target.blur()}
                    popperPlacement="bottom-start"
                    portalId="root-portal"
                    popperClassName="react-datepicker-popper"
                  />
                </FieldWrappers>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="endDate">End Date *</Label>
                <FieldWrappers>
                  {/* <CalendarIcon />
                  <input
                    type="date"
                    id="endDate"
                    {...formik.getFieldProps("endDate")}
                    className="pl-6"
                    min={formik.values.startDate}
                  /> */}
                  <DatePicker
                    selected={formik.values.endDate ? new Date(formik.values.endDate) : null}
                    onChange={(date) => {
                      formik.setFieldValue("endDate", moment(date).format("YYYY-MM-DD"));
                      setEndDateOpen(false);
                    }}
                    onClickOutside={() => setEndDateOpen(false)}
                    onSelect={() => setEndDateOpen(false)}
                    open={endDateOpen}
                    onInputClick={() => setEndDateOpen(true)}
                    dateFormat="yyyy-MM-dd"
                    className="items-center cursor-pointer"
                    placeholderText="Select end date"
                    showIcon
                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                    showPopperArrow={false}
                    minDate={formik.values.startDate ? new Date(formik.values.startDate) : null}
                    wrapperClassName="w-full"
                    name="endDate"
                    id="endDate"
                    autoComplete="off"
                    onFocus={(e) => e.target.blur()}
                    popperPlacement="bottom-start"
                    portalId="root-portal"
                    popperClassName="react-datepicker-popper"
                  />
                </FieldWrappers>
              </InputGroup>
            </CombineInputGroup>
            <InputGroup>
              <Label htmlFor="dueDate">Due Date *</Label>
              <FieldWrappers>
                {/* <CalendarIcon />
                <input
                  type="date"
                  id="dueDate"
                  {...formik.getFieldProps("dueDate")}
                  className="pl-6"
                /> */}
                <DatePicker
                  selected={formik.values.dueDate ? new Date(formik.values.dueDate) : null}
                  onChange={(date) => {
                    formik.setFieldValue("dueDate", moment(date).format("YYYY-MM-DD"));
                    setDueDateOpen(false);
                  }}
                  onClickOutside={() => setDueDateOpen(false)}
                  onSelect={() => setDueDateOpen(false)}
                  open={dueDateOpen}
                  onInputClick={() => setDueDateOpen(true)}
                  dateFormat="yyyy-MM-dd"
                  className="items-center cursor-pointer"
                  placeholderText="Select due date"
                  showIcon
                  icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                  showPopperArrow={false}
                  wrapperClassName="w-full"
                  name="dueDate"
                  id="dueDate"
                  autoComplete="off"
                  onFocus={(e) => e.target.blur()}
                  popperPlacement="bottom-start"
                  portalId="root-portal"
                  popperClassName="react-datepicker-popper"
                // popperModifiers={[
                //   {
                //     name: 'offset',
                //     options: {
                //       offset: [0, 0],
                //     },
                //   },
                // ]}
                />
              </FieldWrappers>
            </InputGroup>


            {/* Description */}
            <InputGroup>
              <Label htmlFor="description">Description</Label>
              <FieldWrapper>
                <Textarea
                  id="description"
                  placeholder="Enter Description"
                  {...formik.getFieldProps("description")}
                  rows={3}

                />
              </FieldWrapper>
            </InputGroup>
          </Wrapper>
        </ScrollableContent>

        {/* Action Buttons */}
        <ActionSection>
          <SideCancelBtn type="button" onClick={() => setSelectedOption(null)}>
            Back
          </SideCancelBtn>
          <SubmitBtn type="submit" disabled={addDuesLoading}>{addDuesLoading ? "Loading..." : "Add Dues"}</SubmitBtn>
        </ActionSection>
      </form>
    </Container>
  );
};

const FieldWrapper = tw.div`w-full`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Textarea = tw.textarea`min-h-30 border rounded pl-2 py-2 w-full h-30 resize-y  break-words overflow-hidden`;

export default OthersModal;
